import {spotheroPatch} from 'api';
import {sendSentryException} from 'utils/error-handling';
/**
 * Updates a given faciliity's inventory with a new default number of available spaces
 * @param {number} facilityId - The facility id.
 * @param {number} ruleId - The rule id.
 * @param {number} maxQuantity - remaining_inventory for non-recurring and total_inventory for recurring inventory
 * @return {Promise<TInventorySpaces>}
 *
 * @see '/api/v1/facilities/{facilityId}/monthly-rental-rules/{ruleId}/'
 */
const updateMonthlyRentalRules = async ({facilityId, ruleId, spaces}) => {
    try {
        const {data} = await spotheroPatch(
            `facilities/${facilityId}/monthly-rental-rules/${ruleId}/`,
            // eslint-disable-next-line camelcase
            {max_quantity: spaces}
        );

        return data?.data?.max_quantity;
    } catch (err) {
        sendSentryException(err);

        throw err;
    }
};

export default updateMonthlyRentalRules;
